module.exports = __webpack_public_path__ + "static/media/people6.16abe1b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/people6.jpg
// module id = 49
// module chunks = 0